import { render } from "./OfficialSellerBadge.vue?vue&type=template&id=e54601c4&scoped=true"
import script from "./OfficialSellerBadge.vue?vue&type=script&lang=js"
export * from "./OfficialSellerBadge.vue?vue&type=script&lang=js"

import "./OfficialSellerBadge.vue?vue&type=style&index=0&id=e54601c4&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e54601c4"]])

export default __exports__